import getLogger from "utils/logger.util";
import ChartConstant from "constants/chartConstant";

const Logger = getLogger("Chart - AlarmUtil");

const getAlarmTraceObj = (alarm, alarmYvalues, bgcolor = "red", legendText = null) => ({
  x: Array(50).fill(new Date(alarm.TimeStamp)),
  y: alarmYvalues,
  hovertemplate: ` ${alarm.AlarmId} <br> %{x|%d %b %Y, %H:%M:%S} <extra></extra>`,
  hoverlabel: { bgcolor },
  type: "scattergl",
  showlegend: Boolean(legendText),
  mode: "lines",
  name: legendText,
  meta: legendText,
  line: { color: bgcolor, width: 1 }
});

const getListMinMax = tagsList => {
  const tagsMin = Math.min(...tagsList);
  const tagsMax = Math.max(...tagsList);
  const isMinMaxZero = tagsMin === 0 && tagsMax === 0;
  const minY = isMinMaxZero ? -1 : tagsMin;
  const maxY = isMinMaxZero ? 1 : tagsMax;
  return { minY: minY * 0.95, maxY: maxY * 1.05 };
};

const getAlarmTraces = (alarm, maxY, minY, linecolor, legendText) => {
  const Yincrement = (maxY - minY) / 49;
  const alarmYvalues = new Array(50);
  alarmYvalues[0] = minY;
  for (let count = 1; count < alarmYvalues.length; count++) {
    alarmYvalues[count] = alarmYvalues[count - 1] + Yincrement;
  }
  return getAlarmTraceObj(alarm, alarmYvalues, linecolor, legendText);
};

const getAlarmTracesAndShapes = (alarms, minY, maxY) => {
  const result = { shapes: [], alarmsTraces: [] };
  if (alarms) {
    alarms.forEach(alarm => {
      const alarmLine = getAlarmLineObj(alarm, minY, maxY);
      result.shapes.push(alarmLine);
      const alarmTrace = getAlarmTraces(alarm, maxY, minY);
      result.alarmsTraces.push(alarmTrace);
    });
  }
  return result;
};

const getAlarmLineObj = (alarm, minY, maxY, color = "red") => {
  const tempDate = new Date(alarm.TimeStamp);
  return {
    x0: tempDate,
    x1: tempDate,
    y0: minY,
    y1: maxY,
    type: "line",
    line: {
      color,
      width: 1
    }
  };
};

const getMultiPlotAlarmTraces = (alarm, tagsList, index, linecolor, legendText) => {
  const { minY, maxY } = getListMinMax(tagsList);
  return {
    ...getAlarmTraces(alarm, maxY, minY, linecolor, legendText),
    xaxis: `x${index + 1}`,
    yaxis: `y${index + 1}`
  };
};

const getMultiPlotAlarmLine = (tagsList, alarm, index, linecolor) => {
  const { minY, maxY } = getListMinMax(tagsList);
  return {
    ...getAlarmLineObj(alarm, minY, maxY, linecolor),
    xref: `x${index + 1}`,
    yref: `y${index + 1}`
  };
};

const getTagsMinMaxYaxis = tags => {
  const tagsWithData = tags.map(tag => tag.Data.filter(x => x !== null));
  const maxYarr = tagsWithData.map(tag => Math.max(...tag));
  const minYarr = tagsWithData.map(tag => Math.min(...tag));
  return { maxYarr, minYarr };
};

export const parseChartAlarms = (Format, chartTagsToShow, alarms, lineColor, legendText) => {
  Logger.log("parseChartAlarms - Format, alarms: ", Format, alarms);
  let chartAlarms = { shapes: [], alarmsTraces: [] };
  const activeAlarms = alarms.filter(alarm => Boolean(alarm.Enable));
  if (activeAlarms.length) {
    if (Format === ChartConstant.CHART_PLOT_FORMATS.SINGLE_PLOT) {
      const { maxYarr, minYarr } = getTagsMinMaxYaxis(chartTagsToShow);
      const maxY = Math.max(...maxYarr);
      const minY = Math.min(...minYarr);
      chartAlarms = getAlarmTracesAndShapes(activeAlarms, minY, maxY);
    } else if (Format === ChartConstant.CHART_PLOT_FORMATS.MULTI_PLOT) {
      const shapes = [];
      const alarmsTraces = [];
      activeAlarms.forEach(alarm => {
        chartTagsToShow.forEach((tag, index) => {
          if (index > 0) legendText = null;
          const baselineVal = tag.Baseline || 0;
          const tagDataPointsNotNull = tag.Data.filter(tag => tag != null);
          tagDataPointsNotNull.push(baselineVal);
          const alarmLine = getMultiPlotAlarmLine(tagDataPointsNotNull, alarm, index, lineColor);
          shapes.push(alarmLine);
          const alarmTrace = getMultiPlotAlarmTraces(alarm, tagDataPointsNotNull, index, lineColor, legendText);
          alarmsTraces.push(alarmTrace);
        });
      });
      chartAlarms = { shapes, alarmsTraces };
    } else if (Format === ChartConstant.CHART_PLOT_FORMATS.MULTI_Y_PLOT) {
      const { maxYarr, minYarr } = getTagsMinMaxYaxis(chartTagsToShow);
      const maxY = Math.max(...maxYarr);
      const minY = Math.min(...minYarr);
      chartAlarms = getAlarmTracesAndShapes(activeAlarms, minY, maxY);
    }
  }
  return chartAlarms;
};
